import React, { useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import styles from './SortControls.module.css';

const SortControls = ({ onSort, isLoading, sortBy, setSortBy, sortOrder, setSortOrder }) => {
  const handleSortByChange = (newSortBy) => {
    setSortBy(newSortBy);
    onSort(newSortBy, sortOrder);
  };

  const handleSortOrderToggle = () => {
    const newOrder = sortOrder === 1 ? 0 : 1;
    setSortOrder(newOrder);
    onSort(sortBy, newOrder);
  };

  const handleClearSort = () => {
    setSortBy(null);
    setSortOrder(null);
    onSort(null, null);
  };

  const getOrderText = () => {
    if (sortBy === 'date') {
      return sortOrder === 1 ? 'Oldest' : 'Newest';
    }
    return sortOrder === 1 ? 'A-Z' : 'Z-A';
  };

  const getOrderTitle = () => {
    if (sortBy === 'date') {
      return sortOrder === 1 ? 'Oldest first' : 'Newest first';
    }
    return sortOrder === 1 ? 'Ascending (A-Z)' : 'Descending (Z-A)';
  };

  return (
    <div className={styles.sortContainer}>
      <div className={styles.sortWrapper}>
        {/* Sort By Section */}
        <div className={styles.sortSection}>
          <span className={styles.sortLabel}>Sort by:</span>
          <div className={styles.sortButtons}>
            <button
              className={`${styles.sortButton} ${sortBy === 'name' ? styles.active : ''}`}
              onClick={() => handleSortByChange('name')}
              disabled={isLoading}
            >
              <svg
                className={styles.buttonIcon}
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M4 6h16M4 12h10M4 18h6" />
              </svg>
              Name
            </button>
            <button
              className={`${styles.sortButton} ${sortBy === 'date' ? styles.active : ''}`}
              onClick={() => handleSortByChange('date')}
              disabled={isLoading}
            >
              <svg
                className={styles.buttonIcon}
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <path d="M16 2v4M8 2v4M3 10h18" />
              </svg>
              Date
            </button>
          </div>
        </div>

        {/* Order Toggle Section */}
        <div className={styles.orderSection}>
          <button
            className={`${styles.orderButton} ${isLoading ? styles.loading : ''}`}
            onClick={handleSortOrderToggle}
            disabled={isLoading}
            title={getOrderTitle()}
          >
            {isLoading ? (
              <CircularProgress size={16} className={styles.loader} />
            ) : (
              <svg
                className={`${styles.orderIcon} ${sortOrder === 1 ? styles.ascending : ''}`}
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M12 5v14M5 12l7-7 7 7" />
              </svg>
            )}
            <span className={styles.orderText}>
              {getOrderText()}
            </span>
          </button>
        </div>

        {/* Clear Sort Button */}
        {(sortBy !== null || sortOrder !== null) && (
          <div className={styles.clearSection}>
            <button
              className={styles.clearButton}
              onClick={handleClearSort}
              disabled={isLoading}
              title="Clear sorting"
            >
              <svg
                className={styles.clearIcon}
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M18 6L6 18M6 6l12 12" />
              </svg>
              <span>Clear</span>
            </button>
          </div>
        )}
      </div>

      {/* Loading Overlay */}

    </div>
  );
};

export default SortControls;
